<app-form-loading-screen *ngIf="showSelfLoader"></app-form-loading-screen>
<div class="mb-20 flex flex-row gap-[20px] w-full">
  <div class="flex-1 contentBox">
    <!-- <span *ngIf="loading">{{ 'Loading' | translate }}...</span> -->
    <div class="flex flex-row gap-[20px] w-full">
      <div class="flex-[100%]">
        <div class="flex flex-row gap-[20px] w-full score-top-row">
          <div class="flex-[25%] score-title-field">
            <mat-form-field class="w-full">
              <mat-label>{{ 'Title' | translate }}</mat-label>
              <input matInput #title name="title" [(ngModel)]="selectedData.title" [required]="true"
                placeholder="{{ 'Title' | translate }}" [errorStateMatcher]="esMatcher" max="200" maxlength="200">
              <mat-error
                *ngIf="title.invalid && title.touched && selectedData.title === undefined || selectedData.title === ''">
                {{ 'Title' | translate }} is required.
              </mat-error>
            </mat-form-field>
          </div>
          <div class="flex-[25%] score-top-spacer">
          </div>
          <div class="flex-[50%] topBtns score-top-actions">
            <button color="primary" mat-raised-button (click)="toggleClick('delete')"
              [disabled]="!selectedData.hasOwnProperty('_id')">{{ 'Delete' | translate }}</button>
            <button color="primary" mat-raised-button (click)="toggleClick('save')">{{ 'Save' |
              translate }}</button>
            <button color="primary" mat-raised-button (click)="toggleClick('new')">{{ 'New' |
              translate }}</button>
          </div>
        </div>
        <!-- </mat-card-content>
            </mat-card> -->
      </div>
    </div>

    <!-- Mobile-only: score report list + added tiles as fullscreen sheets (desktop unchanged) -->
    <div class="mobile-score-toolbar">
      <button mat-raised-button color="primary" type="button" (click)="openMobileScoreList()">
        <mat-icon>list</mat-icon>
        {{ UIDisplay | translate }} {{ 'List' | translate }}
      </button>
      <button mat-raised-button color="primary" type="button"
        (click)="openMobileAddedTiles()"
        [disabled]="!canManageAddedTiles">
        <mat-icon>view_module</mat-icon>
        {{ 'Added Tiles' | translate }}
      </button>
    </div>

    <div class="mb-20 flex flex-row gap-[20px] w-full score-main-row">
      <div class="flex-[25%] score-report-list"
        [class.mobile-sheet-open]="showMobileScoreList">
        <div class="mobile-sheet-header">
          <span class="mobile-sheet-title">
            {{ UIDisplay | translate }} {{ 'List' | translate }}
          </span>
          <button mat-icon-button type="button" (click)="closeMobileScoreList()"
            [attr.aria-label]="'Close' | translate">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <div class="mobile-sheet-body">
          <app-data-list #dataList [dataType]="dataType" [UIDisplay]="UIDisplay" [selectedData]="selectedData"
            (dataListAction)="dataActionReturn($event)" (selectItem)="selectItemCheck($event)"></app-data-list>
        </div>
      </div>
      <div class="flex-[50%] score-options">
        <mat-card>
          <mat-card-header>
            <div class="flex flex-row gap-[0px] w-full">
              <div class="flex-[80%]">
                <mat-card-title>{{UIDisplay | translate}} {{'Options' | translate}} </mat-card-title>
              </div>
              <div class="flex-[20%]">
                <button mat-icon-button align="end" style="visibility: hidden;">
                  Temp
                </button>
              </div>
            </div>
          </mat-card-header>
          <mat-divider></mat-divider>
          <mat-card-content>
            <mat-card class="tileData" *ngFor="let tile of tileStructure">
              <mat-card-header>
                <mat-card-title>Tile: {{tile.name}}</mat-card-title>
                <div class="flex-[1%]"></div>
                <div class="flex justify-center items-center">
                  <button mat-icon-button (click)="tile['collapse'] = !tile['collapse']">
                    <mat-icon *ngIf="tile['collapse']" title="Expand">unfold_more</mat-icon>
                    <mat-icon *ngIf="!tile['collapse']" title="Collapse">unfold_less</mat-icon>
                  </button>
                </div>
              </mat-card-header>
              <mat-divider></mat-divider>
              <mat-card-content>
                <ng-container *ngIf="tile.widgets">
                  <!-- <mat-card class="widgetData" *ngFor="let widget of tile.widgets" [hidden]="tile['collapse']">
                    <mat-card-header>
                      <mat-card-title>{{questionsType[widget.type]}}</mat-card-title>
                    </mat-card-header>
                    <mat-divider></mat-divider>
                    <mat-card-content> -->
                  <div *ngFor="let widget of tile.widgets" [hidden]="tile['collapse']">
                    <ng-container *ngIf="widget.questions">
                      <ng-container *ngIf="isDataArray(widget.questions)">
                        <ng-container *ngFor="let question of widget.questions">
                          <ng-container [ngTemplateOutlet]="questionData"
                            [ngTemplateOutletContext]="{ question: question, tileId: tile.id, widgetId: widget._id }">
                          </ng-container>
                        </ng-container>
                      </ng-container>
                      <ng-container *ngIf="!isDataArray(widget.questions)">
                        <ng-container [ngTemplateOutlet]="questionData"
                          [ngTemplateOutletContext]="{ question: widget.questions, tileId: tile.id, widgetId: widget._id }">
                        </ng-container>
                      </ng-container>
                    </ng-container>
                  </div>

                  <!-- </mat-card-content>
                  </mat-card> -->
                </ng-container>
              </mat-card-content>
            </mat-card>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="flex-[25%] content-list"
        [class.mobile-sheet-open]="showMobileAddedTiles">
        <div class="mobile-sheet-header">
          <span class="mobile-sheet-title">{{ 'Added Tiles' | translate }}</span>
          <button mat-icon-button type="button" (click)="closeMobileAddedTiles()"
            [attr.aria-label]="'Close' | translate">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <div class="mobile-sheet-body">
          <mat-card class="tileData">
            <mat-card-header>
              <div class="flex flex-row gap-[0px] w-full">
                <div class="flex-[80%]">
                  <mat-card-title>{{'Added Tiles' | translate}} </mat-card-title>
                </div>
                <div class="flex-[10%]">
                  <button mat-icon-button align="end" (click)="selectTiles()"
                    [disabled]="!canManageAddedTiles">
                    <mat-icon>edit</mat-icon>
                  </button>
                </div>
              </div>

            </mat-card-header>
            <mat-divider></mat-divider>
            <mat-card-content>
              <div *ngIf="selectedData && selectedData.selectedTiles">
                <div class="data-box" *ngFor="let itm of selectedData.selectedTiles">
                  {{itm.name}}
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #questionData let-question="question" let-tileId="tileId" let-widgetId="widgetId">
  <mat-checkbox class="example-margin" name="{{question.id}}" [(ngModel)]="question['include']"
    (change)="onChangeInclude($event.checked, tileId, widgetId, question.id)" title="{{'Include in calculation'}}">
    {{question.name}}</mat-checkbox>
  <ng-container *ngIf="question.options">
    <div class="flex flex-row gap-[10px] w-full justify-center items-center"
      *ngFor="let opt of question.options; let index = index">
      <div class="flex-[100%]">
        <mat-form-field class="w-full">
          <input type="number" matInput id="opt{{opt.id}}" placeholder="" [(ngModel)]="opt['weight']"
            (change)="onChange($event.target.value, tileId, widgetId, question.id, opt.id, question.options.length)">
        </mat-form-field>
      </div>
      <div class="flex-[100%]">
        {{opt.name}}
      </div>
    </div>
    <mat-divider class="tileDivider"></mat-divider>
  </ng-container>
</ng-template>
